export const makePathToPublic = (path) => process.env.PUBLIC_URL + path;
